module.exports = __webpack_public_path__ + "img/kesehatan.66c53a9a.webp";